var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-title',[_vm._v("Fee Type Rules")]),_c('fee-designations-grid')],1)}
var staticRenderFns = []

export { render, staticRenderFns }